<template>
  <div class="content">
    <div class="mt40 mb40 contentWrap">
      <div class="clearfix">
        <img src="@/assets/img/logo.png" alt="" height="60px" class="fl" />
        <p class="fr fs16 lh60">{{ $t("feeLetter.transactionNo") }}{{ applymentDetail.applymentNo }}</p>
      </div>
      <!-- About This Fee Letter 关于本收费协议 -->
      <div class="mt20">
        <h4 class="fs18 fwb pb30">{{ $t("feeLetter.aboutFeeLetter") }}</h4>
        <div class="mb60">
          <p class="fs16 pb20">
            <span v-if="applymentDetail.businessType == 'COMPREHENSIVE_CUSTOMIZED'">{{ $t("feeLetter.aboutFeeLetter11") }}</span>
            <span v-else-if="applymentDetail.businessType == 'FUND_ADMIN_CUSTOMIZED'">{{ $t("feeLetter.fundAboutFeeLetter11") }}</span>
          </p>
          <p class="fs16 pb20">
            <span v-if="applymentDetail.businessType == 'COMPREHENSIVE_CUSTOMIZED'">{{ $t("feeLetter.aboutFeeLetter12") }}</span>
            <span v-else-if="applymentDetail.businessType == 'FUND_ADMIN_CUSTOMIZED'">{{ $t("feeLetter.fundAboutFeeLetter12") }}</span>
          </p>
          <div>
            <p class="fs16 pb20">
              1.3 This letter is subject to the engagement letter with transaction number [{{ dataForm.newTransactionNumber }}]. For the specific services covered by this letter,
              the terms and conditions of this letter with transaction number [{{ dataForm.transactionNumber }}] shall prevail.
              <span v-if="getTemporaryLanguage == 'zh'">
                本协议受交易代码为[{{ dataForm.newTransactionNumber }}]的业务约定书约束。就本协议所涵盖的具体服务而言，以交易代码为[{{
                  dataForm.transactionNumber
                }}]的本协议所载条款和条件为准。
              </span>
            </p>
          </div>
          <p class="fs16 pb20">
            <!-- {{ $t("feeLetter.aboutFeeLetter14") }} -->
            1.4 By the "we", "us", “our”, "ours", we mean
            {{ dataForm.companyName }}, including its affiliates and its assigned service provider(s).
            <span v-if="getTemporaryLanguage == 'zh'">
              协议中提及的“我方”、“我们”、“我方的”、“我们的”是指
              {{ dataForm.companyName }}，并包括其附属公司及其指定的服务提供商。
            </span>
          </p>
          <div class="fs16 pb20">
            <p v-if="applymentDetail.businessType == 'COMPREHENSIVE_CUSTOMIZED'">
              {{ $t("feeLetter.aboutFeeLetter15") }}
            </p>
            <p v-else-if="applymentDetail.businessType == 'FUND_ADMIN_CUSTOMIZED'">
              <!-- {{ $t("feeLetter.fundAboutFeeLetter15") }} -->
              1.5 This letter is by and between the fund(s) named
              {{ dataForm.fundNameList ? `[${dataForm.fundNameList.toString().replaceAll(",", ", ")}]` : [] }}
              per the request(s) through our Electronic Services (hereinafter called "the Fund(s)"), and us. Each shall be referred to as a "Party" and collectively referred to as
              the "Parties".
              <span v-if="getTemporaryLanguage == 'zh'">
                本协议的签署方为: 通过我们的电子服务系统提交申请的基金{{
                  dataForm.fundNameList ? `[${dataForm.fundNameList.toString().replaceAll(",", "、")}]` : []
                }}(以下简称“贵基金”)和我方签署。以下的单指某方简称“一方”，以下的统称简称“各方”。
              </span>
            </p>
          </div>
          <p class="fs16 pb20">{{ governingLawClause }}</p>
        </div>
      </div>

      <!-- Introduction 引言 -->
      <div>
        <h4 class="fs18 fwb pb30" v-if="applymentDetail.businessGenre == 'COMPANY'">
          {{ $t("feeLetter.introduction") }}
        </h4>
        <h4 class="fs18 fwb pb30" v-else-if="applymentDetail.businessGenre == 'FUND'">
          {{ $t("feeLetter.conditions") }}
        </h4>
        <div class="mb60" v-if="applymentDetail.businessGenre == 'COMPANY'">
          <p class="fs16 pb20">
            {{ $t("feeLetter.introduction21") }}
          </p>
          <div class="fs16 pb20" v-if="getTemporaryLanguage == 'zh'">
            <div class="w-e-text-container">
              <div class="w-e-text" v-html="dataForm.introductionCn"></div>
            </div>
          </div>
          <div class="fs16 pb20" v-else>
            <div class="w-e-text-container">
              <div class="w-e-text" v-html="dataForm.introduction"></div>
            </div>
          </div>
        </div>
        <div class="mb60" v-else-if="applymentDetail.businessGenre == 'FUND'">
          <p class="fs16 pb20">
            WHEREAS, the Fund(s) to be managed by {{ applymentDetail?.questionnaire?.proposedCompanyName || "" }} (the "Fund Manager"), and the Fund(s) desires to appoint us [{{
              dataForm.fundManagerRole
            }}] of the Fund(s). NOW, THEREFORE, in consideration of the mutual promises and agreements contained herein, the parties hereby agree as follows:
            <span v-if="getTemporaryLanguage == 'zh'">
              鉴于贵基金由{{ applymentDetail?.questionnaire?.proposedCompanyName || "" }}(以下简称“贵基金管理公司”)管理，以及贵基金希望任命我方为基金[{{
                dataForm.fundManagerRoleCn
              }}]。 因此，现依据以下包含的相互承诺和协议，各方特此同意如下：
            </span>
          </p>
          <div class="fs16 pb20" v-if="getTemporaryLanguage == 'zh'">
            <div class="w-e-text-container">
              <div class="w-e-text" v-html="dataForm.introductionCn"></div>
            </div>
          </div>
          <div class="fs16 pb20" v-else>
            <div class="w-e-text-container">
              <div class="w-e-text" v-html="dataForm.introduction"></div>
            </div>
          </div>
        </div>
      </div>

      <!-- ⦁	Service Scope and Fees 服务范围以及报价 -->
      <div>
        <h4 class="fs18 fwb pb30">{{ $t("feeLetter.serviceScope") }}</h4>
        <div class="mb60">
          <div>
            <p class="fs16 pb20">
              3.1 Based on our understanding of the
              {{ applymentDetail.businessGenre == "COMPANY" ? "Company" : "Fund(s)" }} as set out in
              {{ applymentDetail.businessGenre == "COMPANY" ? "section 2" : "Clause 1, 2 and 3.1.1" }}
              of this letter, we will assign [{{ dataForm.principal }}] as the person-in-charge for the provision of services specified as below:
              <span v-if="getTemporaryLanguage == 'zh'">
                鉴于本协议{{ applymentDetail.businessGenre == "COMPANY" ? "第2条" : "第1条、第2条和第3.1.1条" }}提及的我们对贵{{
                  applymentDetail.businessGenre == "COMPANY" ? "公司" : "基金"
                }}的理解，我们将安排[{{ dataForm.principalCn }}]为项目的负责人，我们对贵{{ applymentDetail.businessGenre == "COMPANY" ? "公司" : "基金" }}的收费报价如下：
              </span>
            </p>
          </div>
          <div class="fs16 pb20">
            <a :href="dataForm.serviceScopeAndFeesCnUrl.url" target="_" v-if="getTemporaryLanguage == 'zh'">
              <img :src="dataForm.serviceScopeAndFeesCnUrl.url" alt="" class="imgWrap" />
            </a>
            <a :href="dataForm.serviceScopeAndFeesUrl.url" target="_" v-else>
              <img :src="dataForm.serviceScopeAndFeesUrl.url" alt="" class="imgWrap" />
            </a>
          </div>
          <div>
            <p class="fs16 pb10" v-html="$t('feeLetter.ourAbove')" v-if="applymentDetail.businessGenre == 'COMPANY'"></p>
            <p class="fs16 pb10" v-html="$t('feeLetter.fundOurAbove')" v-else-if="applymentDetail.businessGenre == 'FUND'"></p>
            <p class="fs16">{{ $t("feeLetter.notes") }}</p>
            <div class="fs16" v-if="getTemporaryLanguage == 'zh'">
              <div class="w-e-text-container">
                <div class="w-e-text" v-html="dataForm.notesCn"></div>
              </div>
            </div>
            <div class="fs16" v-else>
              <div class="w-e-text-container">
                <div class="w-e-text" v-html="dataForm.notes"></div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- ⦁	Fee Schedule 收费安排 -->
      <div>
        <h4 class="fs18 fwb pb30">{{ $t("feeLetter.feeSchedule") }}</h4>
        <div class="mb60">
          <p class="fs16 pb20">
            4.1 Our fee set out in section 3 shall be billed on [{{ dataForm.feeDate }}] basis and is payable in advance. The
            {{ applymentDetail.businessGenre == "COMPANY" ? "company" : "Fund(s)" }} shall make fully payment within 14 days from the date of our invoice. If you agree to our
            above-mentioned fee quotation, our fee schedule is as follows:
            <span v-if="getTemporaryLanguage == 'zh'">
              我们的收费安排为预收收费。其中，年度服务费用按年预收；季度服务费用按季度预收；按需收费的服务事项按开具的发票金额预收。贵{{
                applymentDetail.businessGenre == "COMPANY" ? "公司" : "基金"
              }}应自收到发票后的14日内完成付款。若您同意我们的上述收费报价，相关的收费（未包括按需收费的服务事项）具体安排如下:
            </span>
          </p>
          <div class="quoteDetailDiv">
            <!-- Quotation定制化服务-报价(列表) -->
            <quotation-list :quotationList="applymentDetail.quotationList" :lang="getTemporaryLanguage" />
          </div>
        </div>
      </div>

      <!-- ⦁	Ending 结语 -->
      <div>
        <h4 class="fs18 fwb pb30">{{ $t("feeLetter.ending") }}</h4>
        <div class="mb30">
          <p class="fs16 pb20">{{ $t("feeLetter.ending51") }}</p>
          <p class="fs16 pb20">
            5.2 If you have further questions, please contact [{{ dataForm.functionary }}] ([{{ dataForm.email }}]).
            <span v-if="getTemporaryLanguage == 'zh'">若您有进一步的疑问，请联系[{{ dataForm.functionaryCn }}] ([{{ dataForm.email }}]).</span>
          </p>
        </div>
      </div>
      <!-- 上标解析 -->
      <div>
        <div class="mb20 transverseLine"></div>
        <p class="fs16 pb20 linkExplain" v-html="$t('feeLetter.superscript01')"></p>
      </div>
    </div>

    <div class="mb30 contentWrap" v-if="applymentDetail.businessType == 'FUND_ADMIN_CUSTOMIZED'">
      <p class="fs18 fwb pb30">
        Appendix 1 Authorized Persons
        <span v-if="getTemporaryLanguage == 'zh'">附录1 授权名单</span>
      </p>
      <div>
        <a :href="dataForm.appendixUrl.url" target="_">
          <img :src="dataForm.appendixUrl.url" alt="" class="imgWrap" />
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import "wangeditor";
import { getAction } from "@/api/common";
import QuotationList from "@/components/ServiceGather/QuotationList";
import { mapState, mapGetters, mapActions } from "vuex";
import { governingLawClauseRegistry } from "./governingLawClause";
export default {
  name: "FeeLetter",
  components: {
    QuotationList,
  },
  data() {
    return {
      dataForm: {
        newTransactionNumber: "",
        transactionNumber: "",
        companyName: "",
        companyNameCn: "",
        fundManagerRole: "",
        fundManagerRoleCn: "",
        introduction: null,
        introductionCn: null,
        principal: "",
        principalCn: "",
        serviceScopeAndFeesUrl: {},
        serviceScopeAndFeesCnUrl: {},
        notes: "",
        notesCn: "",
        feeDate: "",
        functionary: "",
        functionaryCn: "",
        email: "",
        appendixUrl: {},
        fundNameList: [],
      },
    };
  },
  computed: {
    ...mapState("applyment", ["applymentDetail"]),
    ...mapGetters("language", ["getLanguage", "getTemporaryLanguage"]),
    // 第1.6条 管辖法律条款（按申请单国家动态渲染，未匹配显示空）
    governingLawClause() {
      const country = this.applymentDetail?.country;
      const clause = governingLawClauseRegistry[country];
      if (!clause) return "";
      const prefix = "1.6 ";
      // 中文环境：英文 + 中文（与原 aboutFeeLetter16 双语展示一致）
      if (this.getTemporaryLanguage === "zh") {
        return `${prefix}${clause.en} ${clause.cn}`;
      }
      // 英文环境：仅英文
      return `${prefix}${clause.en}`;
    },
  },
  methods: {
    ...mapActions("applyment", ["fetchApplymentDetail", "fetchAdminApplymentDetail"]),
    ...mapActions("language", ["switchTemporaryLanguage"]),
    // 获取收费协议详情 - 前台
    getFeeLetterWeb() {
      return new Promise((resolve, reject) => {
        getAction("/customerFeeLetter/getDetailByApplymentId", {
          applymentId: this.applyId,
        })
          .then(res => {
            const resData = res.data || {};
            resolve(resData);
          })
          .catch(err => {
            reject();
          });
      });
    },
    // 获取收费协议详情 - 后台
    getFeeLetterAdmin(voucher) {
      return new Promise((resolve, reject) => {
        getAction(`/customerFeeLetterDetail/getDetailByApplymentId?applymentId=${this.applyId}&key=${voucher}`, {})
          .then(res => {
            const resData = res.data || {};
            resolve(resData);
          })
          .catch(err => {
            reject();
          });
      });
    },
    // 页面初始化数据整理
    async pageInit(voucher) {
      let resData = {};
      if (voucher) {
        // 获取申请单详情 - 后台用户专用
        await this.fetchAdminApplymentDetail({ id: this.applyId, key: voucher });
        // 获取收费协议详情 - 后台用户
        resData = await this.getFeeLetterAdmin(voucher);
      } else {
        // 前台用户
        await this.fetchApplymentDetail(this.applyId);
        resData = await this.getFeeLetterWeb();
      }
      if (resData.content) {
        // 解析content
        let content = JSON.parse(resData.content) || {};
        // 解析出来还是string，再解析一次
        if (typeof content == "string") {
          content = JSON.parse(content);
        }
        this.dataForm = {
          newTransactionNumber: content.newTransactionNumber || "",
          transactionNumber: content.transactionNumber || "",
          companyName: content.companyName || "",
          companyNameCn: content.companyNameCn || "",
          fundManagerRole: content.fundManagerRole || "Administrator",
          fundManagerRoleCn: content.fundManagerRoleCn || "托管人",
          introduction: content.introduction || null,
          introductionCn: content.introductionCn || null,
          principal: content.principal || "",
          principalCn: content.principalCn || "",
          serviceScopeAndFeesUrl: content.serviceScopeAndFeesUrl || {},
          serviceScopeAndFeesCnUrl: content.serviceScopeAndFeesCnUrl || {},
          notes: content.notes || "",
          notesCn: content.notesCn || "",
          feeDate: content.feeDate || "",
          functionary: content.functionary || "",
          functionaryCn: content.functionaryCn || "",
          email: content.email || "",
          appendixUrl: content.appendixUrl || {},
          fundNameList: content.fundNameList || [],
        };
      }
    },
  },
  created() {
    const query = this.$route.query;
    // 检查url是否存在参数(id)
    if (query.id) {
      this.applyId = query.id;
      // 切换临时语言
      const lang = query.lang;
      this.switchTemporaryLanguage(lang);
      // 路由携带voucher参数，说明是从crm后台跳转过来的
      if (query.voucher) {
        const voucher = decodeURI(query.voucher);
        this.pageInit(voucher);
      } else {
        this.pageInit();
      }
    } else {
      // 缺少参数
      this.$message({
        message: this.$t("common.error.scarce"),
        type: "error",
        duration: 1000,
        onClose: () => {
          this.$router.replace({ path: "/enroll" });
        },
      });
    }
  },
  beforeRouteLeave(to, from, next) {
    // 恢复语言
    this.switchTemporaryLanguage(this.getLanguage);
    location.reload();
    next();
  },
};
</script>

<style>
/* wangeditor样式覆盖 */
.w-e-text-container .w-e-text table tr {
  vertical-align: top;
}
</style>

<style lang="scss" scoped>
.content {
  background: #f1f5fc;
  overflow: hidden;
}

.contentWrap {
  width: 1200px;
  margin: 0 auto;
  background: #fff;
  padding: 30px;
  border-radius: 4px;
}

.imgWrap {
  max-width: 100%;
  height: auto;
}

.transverseLine {
  width: 100%;
  height: 1px;
  background-color: #919db4;
}

.quoteDetailDiv {
  ::v-deep {
    .orange {
      color: #000000 !important;
    }
  }
}

.quoteDetailDiv {
  ::v-deep {
    .blueDark {
      color: #0000cd !important;
    }
  }
}

.linkExplain {
  ::v-deep {
    .blue {
      color: #0000cd !important;
    }
  }
}
</style>
